import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PublicLayout } from "@/components/public/PublicLayout";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";

import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Federations from "@/pages/public/Federations";
import News from "@/pages/public/News";
import NewsDetail from "@/pages/public/NewsDetail";
import Events from "@/pages/public/Events";
import EventDetail from "@/pages/public/EventDetail";
import Contact from "@/pages/public/Contact";

import AdminAuth from "@/pages/admin/AdminAuth";
import Dashboard from "@/pages/admin/Dashboard";
import AdminNews from "@/pages/admin/AdminNews";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminFederations from "@/pages/admin/AdminFederations";
import AdminAbout from "@/pages/admin/AdminAbout";
import AdminContact from "@/pages/admin/AdminContact";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/federations" element={<Federations />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:id" element={<EventDetail />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          <Route path="/admin/login" element={<AdminAuth />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="news" element={<AdminNews />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="federations" element={<AdminFederations />} />
            <Route path="about" element={<AdminAbout />} />
            <Route path="contact" element={<AdminContact />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
